<template>
  <Modal title="分配学习导师" v-model="visible">
    <Form
      ref="assignAdviserForm"
      class="form"
      :model="adviserParam"
      :rules="adviserRule"
      :label-width="80"
    >
      <Row>
        <Col :span="22">
          <Form-item label="学生">
            <Tag v-for="item in userList" :key="item.id" :name="item.id">
              {{ item.id + " - " + item.nickname }}
            </Tag>
          </Form-item>
        </Col>
        <Col :span="16">
          <Form-item label="学习导师" prop="studyAdviserId">
            <AdminUserSelect
              adminGroupCode="userStudyAdviser"
              needDefaultStudyAdviser='0'
              transfer
              v-model="adviserParam.studyAdviserId"
            ></AdminUserSelect>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col span="16">
          <Form-item label="分配原因" prop="reason">
            <Select v-model="adviserParam.reason" clearable>
              <Option value="1" key="1">新生分配</Option>
<!--              <Option value="2" key="2">服务原因更换班主任</Option>-->
              <Option value="3" key="3">离职原因</Option>
              <Option value="4" key="4">投诉属实更换班主任</Option>
              <Option value="5" key="5">无效投诉更换班主任 </Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible = false">取消</Button>
      <Button
        type="primary"
        size="large"
        :loading="loadingAssignAdviser"
        @click="assignAdviser"
        >分配</Button
      >
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'AssignUserStudyAdviserModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    return {
      loadingAssignAdviser: false,
      visible: false,
      adviserParam: {
        studyAdviserId: null,
        reason: ''
      },
      adviserRule: {
        studyAdviserId: [
          { type: 'integer', required: true, message: '请选择学习导师', trigger: 'blur' }
        ],
        reason: [
          { type: 'string', required: true, message: '请选择分配原因', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    assignAdviser () {
      let self = this

      self.$refs.assignAdviserForm.validate((valid) => {
        if (!valid) {
          return
        }
        let idList = self.userList.map(function (element) {
          return element.id
        })
        self.loadingAssignAdviser = true
        let params = { ids: idList.join(','), studyAdviserId: self.adviserParam.studyAdviserId, reason: self.adviserParam.reason }
        self.$http.get('/user/updateStudyAdviser', { params: params }).then(function (res) {
          self.successCallback()
          self.visible = false
          self.loadingAssignAdviser = false
        }).catch(function (e) {
          self.visible = false
          self.loadingAssignAdviser = false
        })
      })
    }
  },
  watch: {
    value (val) {
      this.visible = val
    },
    visible (val) {
      if (!val) {
        this.adviserParam.studyAdviserId = null
        this.$emit('on-close')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AssignUserStudyAdviserModal.vue?aeafc84c